<template>
  <img
    class="inline-block rounded-full"
    :class="classes"
    :src="props.src"
    :alt="props.alt"
  />
</template>

<script setup>
import { computed } from 'vue'
import { getSizeClasses } from './common'

const props = defineProps({
  src: String,
  alt: {
    type: String,
    default: '',
  },
  size: {
    type: String,
    default: 'sm',
  },
})

const classes = computed(() => getSizeClasses(props.size))
</script>
